// A page's query and anchor change independently of quick-view history state.
import { createContext, type ReactNode, useContext, useMemo } from "react";

const PageQuery = createContext({ search: "", hash: "" });

export function PageQueryProvider({
  search,
  hash,
  children,
}: {
  readonly search: string;
  readonly hash: string;
  readonly children: ReactNode;
}) {
  const value = useMemo(() => ({ search, hash }), [search, hash]);
  return <PageQuery value={value}>{children}</PageQuery>;
}

export function usePageQuery() {
  return useContext(PageQuery);
}
